const SYSTEM_PERMISSIONS = {
  CAN_RECEIVE_ADDITIONAL_ROLES: 'CAN_RECEIVE_ADDITIONAL_ROLES',
  MANAGE_ADMISSIONS: 'MANAGE_ADMISSIONS_FOR_ASSOC_COLLEGE', // Account Administrator Specific
  CONFIGURE_INTEGRATIONS: 'CONFIGURE_INTEGRATIONS', // Account Administrator Specific
  PERFORM_ADMISSIONS_TASKS: 'PERFORM_ADMISSIONS_TASKS_FOR_ASSOCIATED_COLLEGE', // Admissions Operations Specific
  PERFORM_VISIT_MANGEMENT_TASKS: 'PERFORM_VISIT_MANAGEMENT_TASKS_FOR_ASSOCIATED_COLLEGE', // Admissions Representative Specific
  MANAGE_COLLEGE_CONTENT: 'MANAGE_COLLEGE_CONTENT', // Content Manager Specific
  MANAGE_COLLEGE_OUTREACH_MESSAGES: 'MANAGE_COLLEGE_OUTREACH_MESSAGES', // Student Outreach Specific
  MANAGE_COLLEGE_APPLICATION_ROUNDS: 'MANAGE_COLLEGE_APPLICATION_ROUNDS', // Application Manager Specific
  TEST_COLLEGE_APPLICATION: 'TEST_COLLEGE_APPLICATION', // Application Manager && Application Tester Specific
  VIEW_STUDENT_INTERESTS: 'VIEW_STUDENT_INTERESTS_FOR_ASSOC_COLLEGE', // Handraiser Specific
  PERFORM_COLLEGE_SEARCH: 'PERFORM_COLLEGE_SEARCH',
  VIEW_ASSOCIATED_COLLEGE_DETAIL: 'VIEW_ASSOCIATED_COLLEGE_DETAIL',
  VIEW_COLLEGE_ENGAGEMENT_METRICS: 'VIEW_COLLEGE_ENGAGEMENT_METRICS',
  MANAGE_CRM_UPLOADS: 'MANAGE_CRM_UPLOADS_FOR_ASSOC_COLLEGE',
  VIEW_APPLICANTS: 'VIEW_APPLICANTS',
  MANAGE_VISITS: 'MANAGE_VISITS_FOR_ASSOCIATED_COLLEGE',
  CAN_VIEW_SHADOW_FEATURES: 'CAN_VIEW_SHADOW_FEATURES',
} as const

export default SYSTEM_PERMISSIONS
type SystemPermissions = typeof SYSTEM_PERMISSIONS
export type PermissionValue = SystemPermissions[keyof SystemPermissions]
